import { lazy } from 'react';

import type { AppRouteConfig } from '@/App/AppRoutes/types';

const DeleteAccountCompletePage = lazy(() =>
  import('@/components/pages/DeleteAccount/DeleteAccountCompletePage').then(({ DeleteAccountCompletePage }) => ({
    default: DeleteAccountCompletePage,
  })),
);

export const DeleteAccountCompleteRoute: AppRouteConfig = {
  key: 'delete-account-complete-page',
  path: '/delete_account_complete/:locale?',
  component: DeleteAccountCompletePage,
};
